import { useState } from 'react'
import kpi from '../../../../kpi.svg'
import { ScoopTextField } from '../../../ui'
import { useDispatch } from 'react-redux'
import { updateKPIPosition, updateKPISize, updateKPITitle } from '../../../../store/actions'
import KPIEdit from '../KPIEdit/KPIEdit'
import { ElementWrapper } from '../../components/ElementWrapper/ElementWrapper'
import styles from './KPI.module.scss'

const KPI = ({ id, title, initialPosition, initialSize, multiProps }) => {
    const dispatch = useDispatch()
    const [inputTitle, setInputTitle] = useState(title)
    const [isEditMode, setIsEditMode] = useState(false)
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const handleTitleChange = (e) => {
        setInputTitle(e.target.value)
        dispatch(updateKPITitle(id, e.target.value))
    }

    const updateKPIPos = (position) => {
        dispatch(updateKPIPosition(id, position))
    }

    const updateKPIsz = (size) => {
        dispatch(updateKPISize(id, size))
    }

    return (
        <ElementWrapper
            id={`KPI-${id}`}
            key={`KPI-${id}`}
            editMode={isEditMode}
            toggleEditMode={setIsEditMode}
            initialSize={initialSize}
            initialPosition={initialPosition}
            updateElementPosition={updateKPIPos}
            updateElementSize={updateKPIsz}
            {...multiProps}
        >
            {isEditMode && (
                <div className={styles.editControls}>
                    <KPIEdit
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                        title={title}
                        id={id}
                    />
                </div>
            )}
            <div className={styles.inputContainer}>
                <ScoopTextField
                    placeholder={title}
                    value={inputTitle}
                    onChange={handleTitleChange}
                />
            </div>
            <div className={styles.kpiVisualization} style={{ backgroundImage: `url(${kpi})` }} />
        </ElementWrapper>
    )
}

export default KPI
